"use client";

import { useEffect, useState } from "react";

type Options = {
  enabled?: boolean;
};

export function useCountdown(
  initialSeconds: number,
  { enabled = true }: Options = {},
): number {
  const [seconds, setSeconds] = useState(initialSeconds);

  useEffect(() => {
    if (!enabled) return;

    const interval = setInterval(() => {
      setSeconds((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          clearInterval(interval);
          return 0;
        }
        return next;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [enabled]);

  return seconds;
}
